package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme

val coreValuesStyle = CssStyle {
    base {
        Modifier
            .padding(32.px)
            .backgroundColor(HLDITheme.Colors.white)
            .borderRadius(12.px)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 2.px,
                blurRadius = 8.px,
                color = Color.rgba(0, 0, 0, 0.08f)
            )
            .transition(
              transition = com.varabyte.kobweb.compose.css.Transition.all(
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }

    hover {
        Modifier
            .translateY((-4).px)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 8.px,
                blurRadius = 24.px,
                color = Color.rgba(0, 0, 0, 0.12f)
            )
    }
}